import React, { useEffect, useState, Suspense } from "react";
import "./App.css";
import Hamburger from "./components/Hamburger";
import NavPage from "./components/NavPage";
import { AnimatePresence } from "framer-motion";
import { Routes, Route, useLocation } from "react-router-dom";
import ProjectNotFound from "./components/ProjectNotFound";
import Loading from "./components/Loading";
import AnimatedCursor from "react-animated-cursor";

const HomeComponent = React.lazy(() => import("./pages/Home"));
const ProjectsComponent = React.lazy(() => import("./pages/Projects"));
const ProjectDetailComponent = React.lazy(() =>
  import("./pages/ProjectDetail")
);
const AboutComponent = React.lazy(() => import("./pages/About"));
const ArticlesComponent = React.lazy(() => import("./pages/Article"));
const ServicesComponent = React.lazy(() => import("./pages/Services"));

function App() {
  const [openBurger, setOpenBurger] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpenBurger(false);
    document.querySelector(".main").scrollTo({ top: 0 , behavior: 'smooth' });
  }, [location]);

  useEffect(() => {
    if (openBurger) {
      document.querySelector(".main").style.overflow = "hidden";
    } else {
      document.querySelector(".main").style.overflow = "auto";
    }
  }, [openBurger]);

  return (
    <div className="main">
      <AnimatedCursor
        innerSize={5}
        outerSize={25}
        innerScale={1.4}
        outerScale={1.9}
        outerAlpha={0}
        hasBlendMode={true}
        innerStyle={{
          backgroundColor: "#52bd81",
        }}
        outerStyle={{
          border: "3px solid #52bd81",
        }}
      />
      <Hamburger openBurger={openBurger} setOpenBurger={setOpenBurger} />
      <AnimatePresence>
        {openBurger && (
          <NavPage openBurger={openBurger} setOpenBurger={setOpenBurger} />
        )}
      </AnimatePresence>
      <AnimatePresence exitBeforeEnter>
        <Suspense fallback={<Loading />}>
          <Routes location={location} key={location.key}>
            <Route path="/" element={<HomeComponent />} />
            {/* <Route
              path="/articles"
              element={
                <ArticlesComponent />
              }
            /> */}
            {/* <Route
              path="/services"
              element={
                <ServicesComponent />
              }
            /> */}
            <Route
              path="/projects"
              element={
                <ProjectsComponent />
              }
            />
            <Route
              path="/projects/:slug"
              element={
                <ProjectDetailComponent />
              }
            />
            <Route path="/about" element={<AboutComponent />} />
            <Route
              path="/*"
              element={<ProjectNotFound message="Page Not Found" />}
            />
          </Routes>
        </Suspense>
      </AnimatePresence>
    </div>
  );
}

export default App;
